var global = require('../internals/global');

module.exports = global.Promise;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/native-promise-constructor.js
// module id = 462
// module chunks = 168707334958949